function injectStyle (ssrContext) {
  require("!!../../node_modules/.pnpm/extract-text-webpack-plugin@3.0.2_webpack@3.12.0/node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.6_vue-t_oicro5fei27gq7zkbv7mmvmnlm/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-a686687c\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.6_vue-t_oicro5fei27gq7zkbv7mmvmnlm/node_modules/vue-loader/lib/selector?type=styles&index=0!./AutoLogin.vue")
}
var normalizeComponent = require("!../../node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.6_vue-t_oicro5fei27gq7zkbv7mmvmnlm/node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../../node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.6_vue-t_oicro5fei27gq7zkbv7mmvmnlm/node_modules/vue-loader/lib/selector?type=script&index=0!./AutoLogin.vue"
import __vue_script__ from "!!babel-loader!../../node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.6_vue-t_oicro5fei27gq7zkbv7mmvmnlm/node_modules/vue-loader/lib/selector?type=script&index=0!./AutoLogin.vue"
/* template */
import __vue_template__ from "!!../../node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.6_vue-t_oicro5fei27gq7zkbv7mmvmnlm/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-a686687c\",\"hasScoped\":true,\"transformToRequire\":{\"video\":[\"src\",\"poster\"],\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../../node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.6_vue-t_oicro5fei27gq7zkbv7mmvmnlm/node_modules/vue-loader/lib/selector?type=template&index=0!./AutoLogin.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a686687c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/AutoLogin.vue
// module id = null
// module chunks = 